import { FloatingPanelContent } from "@babackapp/ui/components/floating-panel";


export default function PanelContent({ title, children }: { title?: string; children: React.ReactNode }) {
	return (
		<FloatingPanelContent>
			<div className="flex flex-col gap-2">
        {title && <div className="items-center font-medium text-xs">{title}</div>}
				<div className="flex w-full">{children}</div>
			</div>
		</FloatingPanelContent>
	);
}
